import React, {useLayoutEffect, useState} from 'react';
import { Helmet } from 'react-helmet';
import ProductsMobile from './products/mobile';
import ProductsDesktop from './products/desktop';
import WindowHelper from '../page-helpers/window-obj';

const getProductHeader = (productName) => {
    let title = null;
    let description = null;
    let keywords = null;

    switch (productName) {
        case 'embeddedswitch':
            title = 'Embedded Smart Switch | Keus Home Automation';
            description = 'Embedded Switch - With no extra wiring, Keus smart switch fits into any Indian gang box. Made for all home appliances, it transforms your living space into a smart home.';
            keywords = 'embedded switch';
            break;

        case 'sceneswitch':
            title = 'Scene  Switch | Keus Home Automation';
            description = 'Keus scene switch, an easy-to-configure device that can be mounted on a wall or used as a portable device. Integrate your AC or light and build a smart home.';
            keywords = 'scene switch';
            break;

        case 'irblaster':
            title = 'IR Blaster - smart remote | Keus Home Automation';
            description = 'A multi-functional Keus smart remote that controls and operates multiple appliances – from AC to TV to music systems – leverage a single point of control with IR Blaster.';
            keywords = 'ir blaster, ir blaster smart home, ir blaster home automation';
            break;

        case 'colourlights':
            title = 'Lighting Automation | Keus Home Automation';
            description = 'Control the ambience of your home through smart lights, an easy-to-install RGB lighting controller, and choose from the personalized range of smart light effects.';
            keywords = 'remote light control, lighting automation, automatic light control, home lighting automation, automatic lighting system';
            break;

        case 'blinds':
            title = 'Smart Blinds | Keus Home Automation';
            description = 'Smart blinds that you can control your curtains from anywhere. Super quiet and the most feature rich curtain control system from Keus.';
            keywords = 'smart blinds, automatic window blinds, automatic curtains, automated blinds';
            break;

        case 'motionsensor':
            title = 'Motion Sensor Lighting | Keus Home Automation';
            description = 'Smart motion sensor system offers a complete motion detection solution. Get security alerts, notifications, and visibility of your entire smart home. Keus - switch to smart home.';
            keywords = 'motion sensor, motion sensor light';
            break;

        case 'doorsensor':
            title = 'Door Sensors | Keus Home Automation';
            description = 'Keus smart contact sensor gives you the safety you need for doors and windows. Suitable for all types of doors and windows.';
            keywords = 'door sensor, door alarm sensor';
            break;

        case 'voice':
            title = 'Voice Controlled Home Automation | Keus Smart Home';
            description = 'Keus smart homes are integrated with smart voice, works with both Alexa and Google Home devices. An easy-to-use voice command that controls all your home appliances.';
            keywords = 'voice control, keus';
            break;
    }

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta property="og:url" content={"https://keus.in/" + productName} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
        </Helmet>
    );
}

export default (props) => {
    const [isMobile, setMobileFlag] = useState(false);

    useLayoutEffect(() => {
        setMobileFlag(WindowHelper.isMobile);
    });

    return (
        <div>
            {getProductHeader(props['*'])}
            {isMobile ? <ProductsMobile productProps={props} /> : <ProductsDesktop productProps={props} />}
        </div>
    );
}